import { ActionReducer } from '@ngrx/store';
import { logout } from './user-state/user.actions';

/**
 * Resets the whole NgRx store on logout.
 *
 * Logout is an in-app navigation (no full page reload), so without this the
 * previous user's cached state — newsfeed posts, comments, notifications — would
 * survive a user switch and briefly leak to the next user. Passing `undefined`
 * as the state makes every slice fall back to its `initialState`.
 *
 * Note: `tenantState` and `layoutState` are preserved. The tenant config is
 * tied to the host, not the user; the layout state is device geometry
 * (screensize/breakpoint) that is only re-dispatched on real window resizes -
 * resetting it left `screensize` null after logout, so every
 * `*flDesktopOnly`/`*flMobileOnly` region rendered empty until the next
 * resize (blank app after switching users).
 */
export function clearStateOnLogout<S>(
  reducer: ActionReducer<S>
): ActionReducer<S> {
  return (state, action) => {
    if (action.type === logout.type) {
      const record = state as Record<string, unknown> | undefined;
      const preserved = record
        ? {
            tenantState: record['tenantState'],
            layoutState: record['layoutState']
          }
        : undefined;
      return reducer(preserved as S, action);
    }

    return reducer(state, action);
  };
}
